import rules from "./rules";
import standardizeValue from "./standardizeValue";

export default function (proposals, answer) {
  const correct = proposals.some(r =>
    rules[r.operator].validate(standardizeValue(answer), r)
  );
  return { correct };
}
